import React from 'react'
import {
    IonButton,
} from '@ionic/react'
import {
    useEditMode,
    useMyRoster,
    useMyRosterIsStale,
    useReady,
} from './data'
import { FaRandom } from 'react-icons/fa'

type GoButtonProps = {
	onAutoRoster: () => void
	onStopAutoRoster: () => void
	noHighlight?: boolean
}

const GoButton = (props: GoButtonProps) => {

    const editMode = useEditMode()
    const ready = useReady()
	    const roster = useMyRoster()
	    const rosterIsStale = useMyRosterIsStale()

	    const highlight = editMode && ready && !props.noHighlight && (rosterIsStale || !roster?.roster?.length)
		const onClick = ready ? props.onAutoRoster : props.onStopAutoRoster

		return (
				<IonButton
                    className={`button-go button-react-icon ${highlight ? 'button-go-highlight' : ''} ${ready ? '' : 'button-go-busy'}`}
	                onClick={onClick}
	                disabled={!editMode}
	                title={ready ? "Automatically generate a roster" : "Stop automatic roster generation"}
	            >
					<FaRandom />
					<span className="roster-button-text">
						{ready ? 'Go' : 'Stop'}
					</span>
				</IonButton>
		)
}

export default GoButton
